import errorMessages from './ERRORS_DE'

const translate = (error: firebase.auth.Error) => {
  return errorMessages[error.code] || error.message
}

export default translate
